import { render, staticRenderFns } from "./BookSection.vue?vue&type=template&id=61c85be0&scoped=true&"
import script from "./BookSection.vue?vue&type=script&lang=js&"
export * from "./BookSection.vue?vue&type=script&lang=js&"
import style0 from "./BookSection.vue?vue&type=style&index=0&id=61c85be0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c85be0",
  null
  
)

export default component.exports